<template>
  <div>
    <div :id="id" :option="option" style="height: 630px;"/>
  </div>
</template>

<script>
import HighCharts from 'highcharts'
import HighMaps from 'highcharts/modules/map'
// 注意：这是API调用方法，千万不要忘记写哦
HighMaps(HighCharts)
export default {
  name: 'Map',
  // 验证类型
  props: {
    id: {
      type: String
    },
    option: {
      type: Object
    }
  },
  watch: {
    option() {
      HighCharts.Map(this.id, this.option)
    }
  },
  mounted() {
    this.option.stops = [
      [0, '#EFEFFF'],
      [0.5, HighCharts.getOptions().colors[0]],
      [1, HighCharts.Color(HighCharts.getOptions().colors[0]).brighten(-0.5).get()]
    ]
    HighCharts.Map(this.id, this.option)
  }
}
</script>

<style scoped>

</style>
